import { render } from "./FollowUpTypesLink.vue?vue&type=template&id=53073959"
import script from "./FollowUpTypesLink.vue?vue&type=script&lang=js"
export * from "./FollowUpTypesLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__